/**
 *  @class
 *  @function ProgressBars
 */
if (!customElements.get('progress-bars')) {
  class ProgressBars extends HTMLElement {
    constructor() {
      super();
      this.progressBarsOuter= this.querySelector('.progress-bars--outer');
      this.progressBarsInner= this.querySelector('.progress-bars--inner');
      this.fixedTable= this.querySelector('.fixedTable');
      this.tableScole= this.querySelector('.tableScole');
      if(this.progressBarsOuter&&document.body.clientWidth>=768){
        this.setPcWidth()
      }
      if(this.fixedTable&&document.body.clientWidth<768){
        this.setMoblieWidth()
      }
    }
    connectedCallback() {

    }
    setPcWidth(){
      this.progressBarsInner.style.paddingLeft=this.progressBarsOuter.offsetWidth+'px'
    }
    setMoblieWidth(){
      this.tableScole.style.marginLeft=this.fixedTable.offsetWidth+'px'
    }
  }
  customElements.define('progress-bars', ProgressBars);
}